import {Controller} from "@/controllers/Controller";

/**
 * Controller for proof API (ms-purchase) : justificatifs d'un achat (le fichier est envoyé tel quel dans le corps de la requête)
 */
export class ProofController extends Controller {

    static upload(purchaseId, file) {
        return this.requestBuilder("POST", `/purchase/proofs/${purchaseId}`, true, file, {
            'Content-Type': file.type,
            'x-file-name': encodeURIComponent(file.name),
        });
    }

    // Fichier brut (blob)
    static download(purchaseId, proofId) {
        return this.requestBuilder("GET", `/purchase/proofs/${purchaseId}/${proofId}`, true, undefined, {'Accept': 'application/pdf'});
    }

    static delete(purchaseId, proofId) {
        return this.requestBuilder("PATCH", `/purchase/proofs/deactivate/${purchaseId}/${proofId}`, true);
    }
}
